import { authFetch } from './authFetch';

export interface ChecklistItem {
  id: number;
  text: string;
  completed: boolean;
}

const API_URL = '/api/checklist/';

export async function fetchChecklist(token: string): Promise<ChecklistItem[]> {
  const res = await authFetch(API_URL, {}, token);
  if (!res.ok) throw new Error('Failed to fetch checklist');
  return res.json();
}

export async function createChecklistItem(token: string, text: string): Promise<ChecklistItem> {
  const res = await authFetch(
    API_URL,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text }),
    },
    token
  );
  if (!res.ok) throw new Error('Failed to create item');
  return res.json();
}

export async function updateChecklistItem(
  token: string,
  id: number,
  completed: boolean
): Promise<ChecklistItem> {
  const res = await authFetch(
    `${API_URL}${id}/`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ completed }),
    },
    token
  );
  if (!res.ok) throw new Error('Failed to update item');
  return res.json();
}

export async function deleteChecklistItem(token: string, id: number): Promise<void> {
  const res = await authFetch(
    `${API_URL}${id}/`,
    {
      method: 'DELETE',
    },
    token
  );
  if (!res.ok) throw new Error('Failed to delete item');
}